import React, { useState } from "react";
import { Dialog, Grid, IconButton, Typography } from "@mui/material";
import { getData, postData, useInterval } from "./UtilityFunctions";

import { postNotification } from "./Notifications";
import moment from "moment-timezone";
import { useConfirm } from "material-ui-confirm";
import {
  BCPCirclePause,
  BCPCirclePlay,
  BCPRotateLeft
} from "../icons/bcp/BCPIcons";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import EventPairingsOverview from "../../pages/events/components/SubComponents/EventPairingsOverview";

export default function CountdownTimer(props) {
  const {
    organize,
    event,
    roundNo,
    timerData,
    setTimerData,
    loading,
    setLoading,
    weeks,
    days,
    animateMinutes,
    overrideLabel,
    pairings
  } = props;
  const confirm = useConfirm();
  const [animate, setAnimate] = useState(false);
  const [open, setOpen] = useState(false);
  const [color, setColor] = useState("inherit");
  const [message1, setMessage1] = useState("##:##:##");
  const [message2, setMessage2] = useState(" Remaining");
  const [delay] = useState(1000);
  const poll = 1000 * 60;
  const overTimeSeconds = getEnvironmentVariable("TIMER_OVERTIME_SECONDS")
    ? parseInt(getEnvironmentVariable("TIMER_OVERTIME_SECONDS"))
    : null;

  const setTimer = async (newTimerData) => {
    if (event) {
      var roundTimers = {
        ...event?.roundTimers,
        [roundNo]: newTimerData
      };
      try {
        setLoading(true);
        await postData(`/events/${event.id}`, {
          body: {
            set: {
              roundTimers: roundTimers
            }
          }
        });
        setTimerData(newTimerData);
      } catch (err) {
        postNotification("error", err);
      }
      setLoading(false);
    }
    return;
  };

  useInterval(() => {
    if (timerData) {
      if (timerData.timerPaused) {
        let h = Math.floor(
          ((timerData.pausedTimeRemaining * 1000) % (1000 * 60 * 60 * 24)) /
            (1000 * 60 * 60)
        );
        let m = Math.floor(
          ((timerData.pausedTimeRemaining * 1000) % (1000 * 60 * 60)) /
            (1000 * 60)
        );
        let s = Math.floor(
          ((timerData.pausedTimeRemaining * 1000) % (1000 * 60)) / 1000
        );

        setMessage1(
          `${("0" + h).slice(-2)}:${("0" + m).slice(-2)}:${("0" + s).slice(-2)}`
        );
        setMessage2(` Paused`);
        setAnimate(true);
      } else {
        var now = new Date().getTime();
        var startTime = timerData.startTime
          ? new Date(timerData.startTime).getTime()
          : undefined;
        var endTime = timerData.endTime
          ? new Date(timerData.endTime).getTime()
          : undefined;

        var compareField = startTime > now ? "startTime" : "endTime";
        var compareTime = startTime > now ? startTime : endTime;
        var distance =
          compareTime > now ? compareTime - now : now - compareTime;

        if (
          clearInterval &&
          ((overTimeSeconds &&
            now > compareTime &&
            roundNo !== event?.currentRound &&
            distance / 1000 > overTimeSeconds) ||
            (overTimeSeconds === undefined && now > compareTime))
        ) {
          setAnimate(true);
          setColor("error.main");
          setMessage1("00:00:00");
          setMessage2("No Time Remaining");
        } else {
          let w = "";
          let d = "";

          if (weeks) {
            w = Math.floor(distance / (1000 * 60 * 60 * 24 * 7));
            w = `${w < 10 ? "0" : ""}${w}:`;
            d = Math.floor(
              (distance % (1000 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24)
            );
            d = `${d < 10 ? "0" : ""}${d}:`;
          } else if (days) {
            d = Math.floor(distance / (1000 * 60 * 60 * 24));
            d = `${d < 10 ? "0" : ""}${d}:`;
          }
          let h = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          let m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let s = Math.floor((distance % (1000 * 60)) / 1000);
          let timerMessage = "";
          let otherMessage = "";
          if (
            (animateMinutes && (m < animateMinutes || now > compareTime)) ||
            (!animateMinutes && ((h === 0 && m < 5) || now > compareTime))
          ) {
            timerMessage = `${w}${d}${("0" + h).slice(-2)}:${(now >
              compareTime &&
            roundNo === event?.currentRound &&
            overTimeSeconds &&
            distance / 1000 > overTimeSeconds
              ? "0" + (m - Math.floor((overTimeSeconds % (1000 * 60)) / 60))
              : "0" + m
            ).slice(-2)}:${("0" + s).slice(-2)}`;

            otherMessage = `${
              overrideLabel
                ? overrideLabel
                : compareField === "startTime" && roundNo === 1
                  ? "Event Begins In"
                  : compareField === "startTime"
                    ? "Round Begins In"
                    : now > compareTime &&
                        roundNo === event?.currentRound &&
                        distance / 1000 > overTimeSeconds
                      ? "Overtime Elapsed"
                      : now > compareTime
                        ? "Overtime"
                        : "Remaining"
            }`;

            if (otherMessage === "Overtime Elapsed") {
              // This checks if the timer is over 24 hours passed overtime. The 86400 is the number of seconds in a day
              if (distance / 1000 > overTimeSeconds + 86400) {
                timerMessage = "00:00:00";
                otherMessage = "No Time Remaining";
              }
            }

            setAnimate(true);
            setColor("error.main");
          } else {
            timerMessage = `${w}${d}${("0" + h).slice(-2)}:${("0" + m).slice(
              -2
            )}:${("0" + s).slice(-2)}`;
            otherMessage = overrideLabel
              ? overrideLabel
              : compareField === "startTime" && roundNo === 1
                ? "Event Begins In"
                : compareField === "startTime"
                  ? "Round Begins In"
                  : `Remaining`;

            setAnimate(false);
          }
          setMessage1(
            overrideLabel || compareField === "startTime"
              ? otherMessage
              : timerMessage
          );
          setMessage2(
            !overrideLabel && compareField !== "startTime"
              ? otherMessage
              : timerMessage
          );
        }
      }
    }
  }, delay);

  const fetchTimer = async () => {
    if (event) {
      try {
        const apiGetData = await getData(`/events/${event?.id}/timer`, {
          queryStringParameters: {
            round: roundNo
          }
        });
        if (
          (!timerData && apiGetData && Object.keys(apiGetData).length) ||
          (apiGetData?.endTime && apiGetData?.endTime !== timerData?.endTime) ||
          apiGetData?.timerPaused !== timerData?.timerPaused ||
          apiGetData?.pausedTimeRemaining !== timerData?.pausedTimeRemaining
        ) {
          setTimerData(apiGetData);
          postNotification(
            "info",
            `Round Timer has been ${
              apiGetData.timerPaused ? "paused" : "updated"
            }`
          );
        }
      } catch (err) {}
    }
  };

  useInterval(() => {
    if (!loading) {
      fetchTimer();
    }
  }, poll);
  if (!timerData) {
    return <></>;
  }

  if (organize) {
    return (
      <>
        <Grid container>
          <Grid item>
            <IconButton
              sx={{ color: "text.primary" }}
              onClick={async (e) => {
                try {
                  await confirm({
                    title: `Reset Timer.`,
                    description:
                      "Are you sure you want to reset the round timer?",
                    dialogProps: {
                      sx: {
                        zIndex: 99999
                      }
                    }
                  });
                } catch (err) {
                  return;
                }
                await setTimer({
                  startTime: moment().utc().toISOString(),
                  timerLength: timerData.timerLength,
                  timerPaused: false,
                  endTime: moment()
                    .add(timerData.timerLength, "seconds")
                    .utc()
                    .toISOString()
                });
              }}
            >
              <BCPRotateLeft />
            </IconButton>
          </Grid>
          <Grid
            item
            onClick={() => setOpen(true)}
            sx={{
              display: "flex",
              flex: "auto",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": {
                cursor: "pointer"
              }
            }}
          >
            <Typography
              sx={{
                color: color,
                animation: animate ? "blinker 1s linear infinite" : "",
                "@keyframes blinker": {
                  "50%": {
                    opacity: 0
                  }
                }
              }}
            >
              {message1} {message2}
            </Typography>
          </Grid>
          <Grid item>
            <IconButton
              sx={{ color: "text.primary" }}
              onClick={async (e) => {
                var newTimerData;
                if (timerData.timerPaused) {
                  newTimerData = {
                    startTime: timerData.startTime,
                    timerLength: timerData.timerLength,
                    timerPaused: false,
                    endTime: moment()
                      .add(timerData.pausedTimeRemaining, "seconds")
                      .utc()
                      .toISOString()
                  };
                } else {
                  newTimerData = {
                    ...timerData,
                    pausedTimeRemaining: moment(timerData.endTime).diff(
                      moment(),
                      "seconds"
                    ),
                    timerPaused: true
                  };
                }
                await setTimer(newTimerData);
              }}
            >
              {timerData.timerPaused ? <BCPCirclePlay /> : <BCPCirclePause />}
            </IconButton>
          </Grid>
        </Grid>
        {pairings && pairings?.length && open ? (
          <EventPairingsOverview
            event={event}
            pairings={pairings}
            organize={organize}
            open={open}
            setOpen={setOpen}
            message1={message1}
            message2={message2}
            color={color}
            animate={animate}
            roundNo={roundNo}
          />
        ) : (
          <Dialog
            fullScreen
            open={open}
            onClose={() => setOpen(false)}
            sx={{
              "& .MuiPaper-root": {
                alignItems: "center",
                justifyContent: "center"
              }
            }}
            onClick={() => setOpen(false)}
          >
            <Typography
              variant="h1"
              sx={{
                color: color,
                animation: animate ? "blinker 1s linear infinite" : "",
                fontSize:
                  message1.trim() === "Event Begins In" ? "18vw" : "22vw",
                "@keyframes blinker": {
                  "50%": {
                    opacity: 0
                  }
                }
              }}
            >
              {message1}
            </Typography>
            <Typography
              variant="h1"
              sx={{
                color: color,
                animation: animate ? "blinker 1s linear infinite" : "",
                fontSize:
                  message2.trim() === "No Time Remaining" ? "9vw" : "15vw",
                "@keyframes blinker": {
                  "50%": {
                    opacity: 0
                  }
                }
              }}
            >
              {message2.trim()}
            </Typography>
          </Dialog>
        )}
      </>
    );
  }

  return (
    <Typography
      onClick={() => setOpen(true)}
      sx={{
        color: color,
        animation: animate ? "blinker 1s linear infinite" : "",
        "&:hover": {
          cursor: "pointer"
        },
        "@keyframes blinker": {
          "50%": {
            opacity: 0
          }
        }
      }}
    >
      {message1} {message2}
    </Typography>
  );
}
